import OrgStatusTag from "@/features/organization/components/OrgStatusTag";

export const Breadcrumbs = ({ trail = [], activeColor, compact = false }) => {
  if (!trail.length) return null;
  const lastIndex = trail.length - 1;

  return (
    <div
      className={`flex flex-wrap items-center text-xs text-muted-foreground ${
        compact ? "gap-1" : "gap-2"
      }`}
    >
      {trail.map((crumb, index) => {
        const isLast = index === lastIndex;
        return (
          <span key={crumb.id} className="flex items-center gap-1">
            <div className="flex items-center gap-1">
              <span
                className={`text-[11px] ${compact ? "" : "px-2 py-1"} ${
                  isLast ? activeColor : "text-muted-foreground"
                }`}
              >
                {crumb.name}
              </span>
              {crumb.status && (
                <OrgStatusTag
                  status={crumb.status}
                  inactiveDate={crumb.inactiveDate}
                  className="text-[9px] shrink-0"
                />
              )}
            </div>
            {!isLast ? (
              <span className="text-muted-foreground">&gt;</span>
            ) : null}
          </span>
        );
      })}
    </div>
  );
};
